import React, { Component } from 'react';
import CountrySelector from './countrySelector.js';
import NetworkSelector from './networkSelector.js';

import './css/apps.css';

export default class Apps extends Component {

  constructor(props){
    super(props);

    this.state = {
      showModal: false,
      countrySelectorKey: 0
    };
  }

  componentDidUpdate(){
    if (this.state.showModal){
      let $modal = window.$('.modal');
      $modal.modal();

      //NOTE: this is a hack to force the country selector to rerender
      $modal.on('shown.bs.modal', _ => {
        // this.setState({countrySelectorKey: this.state.countrySelectorKey+1});
      });

      $modal.on('hidden.bs.modal', _ => {
        this.setState({
          showModal: false
        });
      });
      
    }
  }

  setCoppa(event){
    this.selectedApp.coppa = event.target.checked ? 1 : 0;
    //TODO: use this.state    
    this.forceUpdate();
  }

  setGps(event){
    this.selectedApp.gps_enabled = event.target.value;
    //TODO: use this.state
    this.forceUpdate();
  }
  
  updateApp(){
    this.selectedApp.networks = this.networkSelector.networks;
    // this.selectedApp.floorPrices = this.countrySelector.floorPrices;

    // send to server
    var request = new Request(
      "/ajax/updateApp.php",{
        method: 'POST',
        credentials: "same-origin",
        body: JSON.stringify(this.selectedApp), 
        headers: new Headers()
      });

    fetch(request)
      .then(rsp => rsp.text())
      .then(rspText => console.log(rspText));


    this.notify({
      type: 'success',
      msg: `Successfully Updated ${this.selectedApp.name}`
    });

    //TODO: update state??
    let $modal = window.$('.modal');
    $modal.modal('toggle');
  }

  showSettings(app){
    this.selectedApp = app;
    this.setState({showModal: true});
  }

  notify(msg){
    if (this.props.notifyHandler){
      this.props.notifyHandler(msg);
    }
  }

  
  removeApp(idx){
    if (this.props.removeAppHandler){
      this.props.removeAppHandler(idx);
    }
  }
  
  render() {

    let appSettingsContent = "Content goes here";
    
    if (this.selectedApp){
      let app = this.selectedApp;
      appSettingsContent = (
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title">
              {app.name} Settings
            </h4>
          </div>
          <div className="modal-body">
            <h4>Networks:</h4>
            <NetworkSelector
              networks={this.selectedApp.networks}
              isGame={this.selectedApp.is_game}
              ref={x => this.networkSelector = x}
              key={`network:${this.state.countrySelectorKey}`}
              notifyHandler={this.props.notifyHandler}/>
            <div className="form-group">
              <label className="control-label">
                Allow Google ADX Ads to use GPS data when activated by user?
                <br/>
                (improves CPM)
              </label>
              <select className="form-control input-lg"
                      value={this.selectedApp.gps_enabled}
                      onChange={this.setGps.bind(this)}>
                <option value="1">Yes</option>
                <option value="0">No</option>              
              </select>
            </div>

              
            <h4>Coppa Compliance</h4>
            <input id="coppa"
                   type="checkbox"
                   checked={this.selectedApp.coppa == 1}
                   onChange={this.setCoppa.bind(this)}/>
            Is this app is directed to children under the age of 13?
            { /*
            <h4>Floor Prices:</h4>
            <CountrySelector
              floorPrices={this.selectedApp.floorPrices}
              key={`floor:${this.state.countrySelectorKey}`}
              ref={x => this.countrySelector = x}              
              />
              */ }
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger" data-dismiss="modal">
              Cancel
            </button>
            <button type="button" onClick={this.updateApp.bind(this)}
                    className="btn btn-success">
              Save changes
            </button>
          </div>
        </div>
      );
    }
    
    return (
      <div id="apps">
        <h3>Your Apps</h3>
        <p></p>
        <div>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Package Name</th>
                  <th>AppBid ClientId</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.props.apps.map((app, idx) => (
                  <tr key={idx}>
                    <td>
                      <img height="50" className="app-icon" src={`/icon.php?package=${app.package}`} />
                      {app.name}
                    </td>
                    <td>
                      {app.package}
                    </td>
                    <td>
                      {app.clientId}
                    </td>
                    <td>
                      <span
                         className={app.status === "Activated" ?
                                    "text-success" : "text-warning"}>
                        {app.status}
                      </span>
                    </td>
                    <td className={"app-buttons "+
                        (this.props.isAdmin ? "admin" : "")}>

                      {this.props.isAdmin && (
                        <a className="btn btn-success"
                           href={`http://54.146.175.144:5000/new-client-id?client_id=${app.clientId}`}
                           target="_blank">Configure Credentials</a>
                      )}
                      
                      <button className="btn btn-danger" onClick={_ => { this.removeApp(idx); }}>
                        <i className="fa fa-times fa-lg" aria-hidden="true"></i>
                      </button>
                      <button className="btn btn-primary" onClick={_ => { this.showSettings(app); }}>
                        <i className="fa fa-cog fa-lg" aria-hidden="true"></i>
                      </button>

                    </td>
                  </tr>))}
              </tbody>
            </table>
          </div>
        </div>

      {this.state.showModal && (
        <div className="modal fade" id="myModal" tabIndex="-1" role="dialog">
         <div className="modal-dialog modal-lg" role="document">
          {appSettingsContent}
         </div>
        </div>
      )}
      
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/apps.js